module.exports = __webpack_public_path__ + "img/37_35.202ad960.png";